import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const BuildingInfrastructureSection = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-sm-12 col-md-12 col-lg-6">
        <h2>Building &amp; Infrastructure</h2>
        <p id="Doctors_Services">
          Kanha Medical Centre located at Kanha Shati Vanam, Chegur village
          caters to the medical needs of people at Kanha village and surrounding
          villages. The centre is rightly located to provide medical facilities
          quite specialized to address most of the common medical illnesses and
          emergencies. Located far away from the city, the medical facility
          saves valuable time and hence proved to be lifesaving. The nearest
          corporate hospital is 40 minutes away from Kanha Medical Centre.
        </p>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-6">
        <StaticImage
          src="../../../assets/images/kmc-images/bi.png"
          alt="Listing Activities"
        />
      </div>
    </div>
  );
};

export default BuildingInfrastructureSection;
